import { render, staticRenderFns } from "./PressLinks.vue?vue&type=template&id=ff6b178c"
import script from "./PressLinks.vue?vue&type=script&lang=js"
export * from "./PressLinks.vue?vue&type=script&lang=js"
import style0 from "./PressLinks.vue?vue&type=style&index=0&id=ff6b178c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports